module.exports = __webpack_public_path__ + "static/media/dove_bg.982f49dc.svg";